<template>
    <div>
        <router-view :url="url" v-on:updateTitle="updateTitle"></router-view>
    </div>
</template>

<script>
export default {
  name: 'Book',
  computed: {
    url: function () {
      return process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/books'
    }
  },
  created: function () {
    this.$emit('activeMenu', '/admin/books')
    this.$emit('newLink', '/admin/books/create')
    this.$emit('updateDisable', false)
  },
  methods: {
    updateTitle (val) {
      this.$emit('updateTitle', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/book/Book.vue